import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelAutoCompleteWithRefInput
} from "../FormSectionComponents";

const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class DefinitionsChildSection extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <div id="covenants_section_definitions">
        <ChildSectionTitle>Definitions</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">

          <SideLabelTextAreaWithRefInput label="NOI" hasBorder placeholder="NOI" fieldName="covenants.noiDefinition" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Debt Service" hasBorder placeholder="Debt Service" fieldName="covenants.debtServiceDefinition" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Debt Yield" hasBorder placeholder="Debt Yield" fieldName="covenants.debtYieldDefinition" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="DSCR" hasBorder placeholder="DSCR" fieldName="covenants.dscrDefinition" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="LTV" hasBorder placeholder="LTV" fieldName="covenants.ltvDefinition" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput
            label="Misc."
            placeholder="Misc."
            fieldName="covenants.definitionsMisc"
            isDisabled={!isEditing}
          />
        </StyledGrid>
      </div>
    );
  }
}
export default DefinitionsChildSection;
